import { Component, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';

@Component({
  selector: 'app-task-actions-history',
  templateUrl: './task-actions-history.component.html',
  styleUrls: ['./task-actions-history.component.scss']
})
export class TaskActionsHistoryComponent implements OnInit {

  isProcessing = true;
  getOneQmsTaskActionsHistoryVwDetails: any = [];

  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public paginationService: PaginationService,
    public message: messageService, public qmsservice: qmsService, private readonly elem: ElementRef) {

  }

  ngOnInit() {
    this.appService.getOneQmsTaskActionsHistoryVwDetails(this.qmsservice.activityId).subscribe((data: any) => {
      this.getOneQmsTaskActionsHistoryVwDetails = data;
      this.isProcessing = false;
    })
  }

}
